import { Link } from "../../components/Link";
import { VideoFeed } from "../../components/VideoFeed";

export default function Page() {
  const title = "LIVE STAFF DEMO";
  const descriptionText =
    "Use a staff, practice pole, or broom handle in a clear space to preview AI-assisted form tracking.";

  return (
    <main id="main-content">
      <div className="absolute top-4 left-4">
        <Link
          href="/"
          aria-label="Back to home"
          className="rounded-md border-2 border-red-600 bg-white px-4 py-2 font-cinzel text-sm font-bold uppercase tracking-wider text-red-600 shadow-md transition-colors duration-200 ease-in-out hover:bg-red-50 hover:text-red-700 hover:shadow-lg focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-red-600"
        >
          Back to Home
        </Link>
      </div>
      <VideoFeed
        title={title}
        description={descriptionText}
      />
    </main>
  );
}
